/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {generateUUID, getCookie, getSetting, setCookie, setDefaultHeaders} from '@dvrd/dvr-controls';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import {CookieAttributes} from 'js-cookie';
import Vehicle from '../models/vehicleModel';
import {VehicleType} from './interfaces';

export const createErrorMessage = (message: string): string =>
    `${message} Probeer het later opnieuw of neem contact met ons op.`;


export const setDeviceId = () => {
    let deviceId = getCookie('dvr-apps-device-id');
    if (!deviceId) {
        deviceId = generateUUID();
        let options: CookieAttributes = {expires: 365};
        if (getSetting('mode') !== 'dev') {
            options.secure = true;
            options.sameSite = 'strict';
        }
        setCookie('dvr-apps-device-id', deviceId, options);
    }
    setDefaultHeaders({'X-Device-Id': deviceId});
};

export function getVehicleIcon(vehicle: Vehicle | null): IconName {
    if (!vehicle) return 'triangle-exclamation';
    return ({
        [VehicleType.CAR]: 'car',
        [VehicleType.MOTOR]: 'motorcycle',
        [VehicleType.VAN]: 'van-shuttle'
    } as Record<string, IconName>)[vehicle.vehicleType];
}

export function getVehicleLabel(vehicle: Vehicle | null, nullLabel?: string) {
    if (!vehicle) return nullLabel ?? 'Selecteer een voertuig';
    return `${vehicle.licenceNumber} - ${vehicle.label}`;
}